import React from "react";
import { Link } from "react-router-dom";

const ElementSidbarGroup = (props) => {
  const { title } = props;

  return (
    <li className="relative mt-0.5">
      <p className="flex items-center px-4 py-2 text-textColor dark:text-darkTextColor"  >
        <span className="font-bold ">{title}</span>
      </p>
    </li>
  );
};

export default ElementSidbarGroup;
